// source: xcommon/phonesale.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var xcommon_common_pb = require('../xcommon/common_pb.js');
goog.object.extend(proto, xcommon_common_pb);
var xcommon_ticket_pb = require('../xcommon/ticket_pb.js');
goog.object.extend(proto, xcommon_ticket_pb);
var xcommon_collection_pb = require('../xcommon/collection_pb.js');
goog.object.extend(proto, xcommon_collection_pb);
goog.exportSymbol('proto.xcommon.GetPhoneSaleCaseLogReq', null, global);
goog.exportSymbol('proto.xcommon.GetPhoneSaleCaseLogResp', null, global);
goog.exportSymbol('proto.xcommon.GetPhoneSaleCaseReq', null, global);
goog.exportSymbol('proto.xcommon.GetPhoneSaleCaseResp', null, global);
goog.exportSymbol('proto.xcommon.GetPhoneSaleListReq', null, global);
goog.exportSymbol('proto.xcommon.GetPhoneSaleListResp', null, global);
goog.exportSymbol('proto.xcommon.PhoneSaleAction', null, global);
goog.exportSymbol('proto.xcommon.PhoneSaleCaseLogBackend', null, global);
goog.exportSymbol('proto.xcommon.PhoneSaleNextStep', null, global);
goog.exportSymbol('proto.xcommon.PhoneSaleTicket', null, global);
goog.exportSymbol('proto.xcommon.PhoneSaleType', null, global);
goog.exportSymbol('proto.xcommon.SavePhoneSaleCaseReq', null, global);
goog.exportSymbol('proto.xcommon.SavePhoneSaleCaseResp', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetPhoneSaleListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetPhoneSaleListReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetPhoneSaleListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetPhoneSaleListReq.displayName = 'proto.xcommon.GetPhoneSaleListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetPhoneSaleListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetPhoneSaleListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetPhoneSaleListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetPhoneSaleListResp.displayName = 'proto.xcommon.GetPhoneSaleListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PhoneSaleTicket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.PhoneSaleTicket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PhoneSaleTicket.displayName = 'proto.xcommon.PhoneSaleTicket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetPhoneSaleCaseReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetPhoneSaleCaseReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetPhoneSaleCaseReq.displayName = 'proto.xcommon.GetPhoneSaleCaseReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetPhoneSaleCaseResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetPhoneSaleCaseResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetPhoneSaleCaseResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetPhoneSaleCaseResp.displayName = 'proto.xcommon.GetPhoneSaleCaseResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SavePhoneSaleCaseReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SavePhoneSaleCaseReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SavePhoneSaleCaseReq.displayName = 'proto.xcommon.SavePhoneSaleCaseReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SavePhoneSaleCaseResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SavePhoneSaleCaseResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SavePhoneSaleCaseResp.displayName = 'proto.xcommon.SavePhoneSaleCaseResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetPhoneSaleCaseLogReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetPhoneSaleCaseLogReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetPhoneSaleCaseLogReq.displayName = 'proto.xcommon.GetPhoneSaleCaseLogReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetPhoneSaleCaseLogResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetPhoneSaleCaseLogResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetPhoneSaleCaseLogResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetPhoneSaleCaseLogResp.displayName = 'proto.xcommon.GetPhoneSaleCaseLogResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PhoneSaleCaseLogBackend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.PhoneSaleCaseLogBackend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PhoneSaleCaseLogBackend.displayName = 'proto.xcommon.PhoneSaleCaseLogBackend';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetPhoneSaleListReq.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetPhoneSaleListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetPhoneSaleListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetPhoneSaleListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPhoneSaleListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    action: jspb.Message.getFieldWithDefault(msg, 3, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    phonesaleitemList: jspb.Message.toObjectList(msg.getPhonesaleitemList(),
    xcommon_ticket_pb.PhoneSaleItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetPhoneSaleListReq}
 */
proto.xcommon.GetPhoneSaleListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetPhoneSaleListReq;
  return proto.xcommon.GetPhoneSaleListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetPhoneSaleListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetPhoneSaleListReq}
 */
proto.xcommon.GetPhoneSaleListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.PhoneSaleAction} */ (reader.readEnum());
      msg.setAction(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 5:
      var value = new xcommon_ticket_pb.PhoneSaleItem;
      reader.readMessage(value,xcommon_ticket_pb.PhoneSaleItem.deserializeBinaryFromReader);
      msg.addPhonesaleitem(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetPhoneSaleListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetPhoneSaleListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetPhoneSaleListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPhoneSaleListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
  f = message.getPhonesaleitemList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      xcommon_ticket_pb.PhoneSaleItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetPhoneSaleListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetPhoneSaleListReq} returns this
*/
proto.xcommon.GetPhoneSaleListReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetPhoneSaleListReq} returns this
 */
proto.xcommon.GetPhoneSaleListReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetPhoneSaleListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetPhoneSaleListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.xcommon.GetPhoneSaleListReq} returns this
*/
proto.xcommon.GetPhoneSaleListReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetPhoneSaleListReq} returns this
 */
proto.xcommon.GetPhoneSaleListReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetPhoneSaleListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PhoneSaleAction Action = 3;
 * @return {!proto.xcommon.PhoneSaleAction}
 */
proto.xcommon.GetPhoneSaleListReq.prototype.getAction = function() {
  return /** @type {!proto.xcommon.PhoneSaleAction} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.xcommon.PhoneSaleAction} value
 * @return {!proto.xcommon.GetPhoneSaleListReq} returns this
 */
proto.xcommon.GetPhoneSaleListReq.prototype.setAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 OrderId = 4;
 * @return {string}
 */
proto.xcommon.GetPhoneSaleListReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetPhoneSaleListReq} returns this
 */
proto.xcommon.GetPhoneSaleListReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * repeated PhoneSaleItem PhoneSaleItem = 5;
 * @return {!Array<!proto.xcommon.PhoneSaleItem>}
 */
proto.xcommon.GetPhoneSaleListReq.prototype.getPhonesaleitemList = function() {
  return /** @type{!Array<!proto.xcommon.PhoneSaleItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_ticket_pb.PhoneSaleItem, 5));
};


/**
 * @param {!Array<!proto.xcommon.PhoneSaleItem>} value
 * @return {!proto.xcommon.GetPhoneSaleListReq} returns this
*/
proto.xcommon.GetPhoneSaleListReq.prototype.setPhonesaleitemList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.xcommon.PhoneSaleItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.PhoneSaleItem}
 */
proto.xcommon.GetPhoneSaleListReq.prototype.addPhonesaleitem = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.xcommon.PhoneSaleItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetPhoneSaleListReq} returns this
 */
proto.xcommon.GetPhoneSaleListReq.prototype.clearPhonesaleitemList = function() {
  return this.setPhonesaleitemList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetPhoneSaleListResp.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetPhoneSaleListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetPhoneSaleListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetPhoneSaleListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPhoneSaleListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.PhoneSaleTicket.toObject, includeInstance),
    phonesaleitemList: jspb.Message.toObjectList(msg.getPhonesaleitemList(),
    xcommon_ticket_pb.PhoneSaleItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetPhoneSaleListResp}
 */
proto.xcommon.GetPhoneSaleListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetPhoneSaleListResp;
  return proto.xcommon.GetPhoneSaleListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetPhoneSaleListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetPhoneSaleListResp}
 */
proto.xcommon.GetPhoneSaleListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.PhoneSaleTicket;
      reader.readMessage(value,proto.xcommon.PhoneSaleTicket.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 4:
      var value = new xcommon_ticket_pb.PhoneSaleItem;
      reader.readMessage(value,xcommon_ticket_pb.PhoneSaleItem.deserializeBinaryFromReader);
      msg.addPhonesaleitem(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetPhoneSaleListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetPhoneSaleListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetPhoneSaleListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPhoneSaleListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.PhoneSaleTicket.serializeBinaryToWriter
    );
  }
  f = message.getPhonesaleitemList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      xcommon_ticket_pb.PhoneSaleItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetPhoneSaleListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetPhoneSaleListResp} returns this
*/
proto.xcommon.GetPhoneSaleListResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetPhoneSaleListResp} returns this
 */
proto.xcommon.GetPhoneSaleListResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetPhoneSaleListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetPhoneSaleListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.xcommon.GetPhoneSaleListResp} returns this
*/
proto.xcommon.GetPhoneSaleListResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetPhoneSaleListResp} returns this
 */
proto.xcommon.GetPhoneSaleListResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetPhoneSaleListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated PhoneSaleTicket List = 3;
 * @return {!Array<!proto.xcommon.PhoneSaleTicket>}
 */
proto.xcommon.GetPhoneSaleListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.PhoneSaleTicket>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.PhoneSaleTicket, 3));
};


/**
 * @param {!Array<!proto.xcommon.PhoneSaleTicket>} value
 * @return {!proto.xcommon.GetPhoneSaleListResp} returns this
*/
proto.xcommon.GetPhoneSaleListResp.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.PhoneSaleTicket=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.PhoneSaleTicket}
 */
proto.xcommon.GetPhoneSaleListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.PhoneSaleTicket, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetPhoneSaleListResp} returns this
 */
proto.xcommon.GetPhoneSaleListResp.prototype.clearListList = function() {
  return this.setListList([]);
};


/**
 * repeated PhoneSaleItem PhoneSaleItem = 4;
 * @return {!Array<!proto.xcommon.PhoneSaleItem>}
 */
proto.xcommon.GetPhoneSaleListResp.prototype.getPhonesaleitemList = function() {
  return /** @type{!Array<!proto.xcommon.PhoneSaleItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_ticket_pb.PhoneSaleItem, 4));
};


/**
 * @param {!Array<!proto.xcommon.PhoneSaleItem>} value
 * @return {!proto.xcommon.GetPhoneSaleListResp} returns this
*/
proto.xcommon.GetPhoneSaleListResp.prototype.setPhonesaleitemList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.xcommon.PhoneSaleItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.PhoneSaleItem}
 */
proto.xcommon.GetPhoneSaleListResp.prototype.addPhonesaleitem = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.xcommon.PhoneSaleItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetPhoneSaleListResp} returns this
 */
proto.xcommon.GetPhoneSaleListResp.prototype.clearPhonesaleitemList = function() {
  return this.setPhonesaleitemList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PhoneSaleTicket.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PhoneSaleTicket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PhoneSaleTicket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PhoneSaleTicket.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticket: (f = msg.getTicket()) && xcommon_ticket_pb.Ticket.toObject(includeInstance, f),
    accountname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    assignname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    orderstatus: jspb.Message.getFieldWithDefault(msg, 4, ""),
    phonesaletag: jspb.Message.getFieldWithDefault(msg, 5, ""),
    accountstatus: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PhoneSaleTicket}
 */
proto.xcommon.PhoneSaleTicket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PhoneSaleTicket;
  return proto.xcommon.PhoneSaleTicket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PhoneSaleTicket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PhoneSaleTicket}
 */
proto.xcommon.PhoneSaleTicket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_ticket_pb.Ticket;
      reader.readMessage(value,xcommon_ticket_pb.Ticket.deserializeBinaryFromReader);
      msg.setTicket(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderstatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonesaletag(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PhoneSaleTicket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PhoneSaleTicket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PhoneSaleTicket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PhoneSaleTicket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicket();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_ticket_pb.Ticket.serializeBinaryToWriter
    );
  }
  f = message.getAccountname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAssignname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOrderstatus();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPhonesaletag();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAccountstatus();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional Ticket Ticket = 1;
 * @return {?proto.xcommon.Ticket}
 */
proto.xcommon.PhoneSaleTicket.prototype.getTicket = function() {
  return /** @type{?proto.xcommon.Ticket} */ (
    jspb.Message.getWrapperField(this, xcommon_ticket_pb.Ticket, 1));
};


/**
 * @param {?proto.xcommon.Ticket|undefined} value
 * @return {!proto.xcommon.PhoneSaleTicket} returns this
*/
proto.xcommon.PhoneSaleTicket.prototype.setTicket = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.PhoneSaleTicket} returns this
 */
proto.xcommon.PhoneSaleTicket.prototype.clearTicket = function() {
  return this.setTicket(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.PhoneSaleTicket.prototype.hasTicket = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string AccountName = 2;
 * @return {string}
 */
proto.xcommon.PhoneSaleTicket.prototype.getAccountname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneSaleTicket} returns this
 */
proto.xcommon.PhoneSaleTicket.prototype.setAccountname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string AssignName = 3;
 * @return {string}
 */
proto.xcommon.PhoneSaleTicket.prototype.getAssignname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneSaleTicket} returns this
 */
proto.xcommon.PhoneSaleTicket.prototype.setAssignname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string OrderStatus = 4;
 * @return {string}
 */
proto.xcommon.PhoneSaleTicket.prototype.getOrderstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneSaleTicket} returns this
 */
proto.xcommon.PhoneSaleTicket.prototype.setOrderstatus = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string PhoneSaleTag = 5;
 * @return {string}
 */
proto.xcommon.PhoneSaleTicket.prototype.getPhonesaletag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneSaleTicket} returns this
 */
proto.xcommon.PhoneSaleTicket.prototype.setPhonesaletag = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string AccountStatus = 6;
 * @return {string}
 */
proto.xcommon.PhoneSaleTicket.prototype.getAccountstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneSaleTicket} returns this
 */
proto.xcommon.PhoneSaleTicket.prototype.setAccountstatus = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetPhoneSaleCaseReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetPhoneSaleCaseReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetPhoneSaleCaseReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPhoneSaleCaseReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    caseid: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetPhoneSaleCaseReq}
 */
proto.xcommon.GetPhoneSaleCaseReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetPhoneSaleCaseReq;
  return proto.xcommon.GetPhoneSaleCaseReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetPhoneSaleCaseReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetPhoneSaleCaseReq}
 */
proto.xcommon.GetPhoneSaleCaseReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetPhoneSaleCaseReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetPhoneSaleCaseReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetPhoneSaleCaseReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPhoneSaleCaseReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetPhoneSaleCaseReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetPhoneSaleCaseReq} returns this
*/
proto.xcommon.GetPhoneSaleCaseReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetPhoneSaleCaseReq} returns this
 */
proto.xcommon.GetPhoneSaleCaseReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetPhoneSaleCaseReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 CaseId = 2;
 * @return {number}
 */
proto.xcommon.GetPhoneSaleCaseReq.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetPhoneSaleCaseReq} returns this
 */
proto.xcommon.GetPhoneSaleCaseReq.prototype.setCaseid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetPhoneSaleCaseResp.repeatedFields_ = [14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetPhoneSaleCaseResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetPhoneSaleCaseResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPhoneSaleCaseResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    useraccountname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    loanamount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    orderstatus: jspb.Message.getFieldWithDefault(msg, 5, ""),
    invalidtime: jspb.Message.getFieldWithDefault(msg, 6, 0),
    phoneconnectedmapMap: (f = msg.getPhoneconnectedmapMap()) ? f.toObject(includeInstance, undefined) : [],
    phoneunconnectedmapMap: (f = msg.getPhoneunconnectedmapMap()) ? f.toObject(includeInstance, undefined) : [],
    phoneconnected: jspb.Message.getFieldWithDefault(msg, 9, 0),
    desc: jspb.Message.getFieldWithDefault(msg, 10, ""),
    result: jspb.Message.getFieldWithDefault(msg, 11, 0),
    mobile: jspb.Message.getFieldWithDefault(msg, 12, ""),
    phoneinfo: (f = msg.getPhoneinfo()) && xcommon_collection_pb.PhoneInfos.toObject(includeInstance, f),
    suppliertypeList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f,
    displayrawphone: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    isgp: jspb.Message.getFieldWithDefault(msg, 16, 0),
    accountstatus: jspb.Message.getFieldWithDefault(msg, 17, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetPhoneSaleCaseResp}
 */
proto.xcommon.GetPhoneSaleCaseResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetPhoneSaleCaseResp;
  return proto.xcommon.GetPhoneSaleCaseResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetPhoneSaleCaseResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetPhoneSaleCaseResp}
 */
proto.xcommon.GetPhoneSaleCaseResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUseraccountname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoanamount(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderstatus(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInvalidtime(value);
      break;
    case 7:
      var value = msg.getPhoneconnectedmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    case 8:
      var value = msg.getPhoneunconnectedmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPhoneconnected(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setDesc(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setResult(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 13:
      var value = new xcommon_collection_pb.PhoneInfos;
      reader.readMessage(value,xcommon_collection_pb.PhoneInfos.deserializeBinaryFromReader);
      msg.setPhoneinfo(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.addSuppliertype(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisplayrawphone(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsgp(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetPhoneSaleCaseResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetPhoneSaleCaseResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPhoneSaleCaseResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getUseraccountname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getLoanamount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getOrderstatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getInvalidtime();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getPhoneconnectedmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(7, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getPhoneunconnectedmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(8, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getPhoneconnected();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getDesc();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getResult();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getPhoneinfo();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      xcommon_collection_pb.PhoneInfos.serializeBinaryToWriter
    );
  }
  f = message.getSuppliertypeList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      14,
      f
    );
  }
  f = message.getDisplayrawphone();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getIsgp();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getAccountstatus();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetPhoneSaleCaseResp} returns this
*/
proto.xcommon.GetPhoneSaleCaseResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetPhoneSaleCaseResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string UserAccountName = 2;
 * @return {string}
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.getUseraccountname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetPhoneSaleCaseResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.setUseraccountname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 OrderID = 3;
 * @return {string}
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetPhoneSaleCaseResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int64 LoanAmount = 4;
 * @return {number}
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.getLoanamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetPhoneSaleCaseResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.setLoanamount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string OrderStatus = 5;
 * @return {string}
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.getOrderstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetPhoneSaleCaseResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.setOrderstatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 InvalidTime = 6;
 * @return {number}
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.getInvalidtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetPhoneSaleCaseResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.setInvalidtime = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * map<int32, string> PhoneConnectedMap = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.getPhoneconnectedmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.GetPhoneSaleCaseResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.clearPhoneconnectedmapMap = function() {
  this.getPhoneconnectedmapMap().clear();
  return this;
};


/**
 * map<int32, string> PhoneUnConnectedMap = 8;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.getPhoneunconnectedmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 8, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.GetPhoneSaleCaseResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.clearPhoneunconnectedmapMap = function() {
  this.getPhoneunconnectedmapMap().clear();
  return this;
};


/**
 * optional int32 PhoneConnected = 9;
 * @return {number}
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.getPhoneconnected = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetPhoneSaleCaseResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.setPhoneconnected = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string Desc = 10;
 * @return {string}
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.getDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetPhoneSaleCaseResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.setDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int32 Result = 11;
 * @return {number}
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.getResult = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetPhoneSaleCaseResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.setResult = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string Mobile = 12;
 * @return {string}
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetPhoneSaleCaseResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.setMobile = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional PhoneInfos PhoneInfo = 13;
 * @return {?proto.xcommon.PhoneInfos}
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.getPhoneinfo = function() {
  return /** @type{?proto.xcommon.PhoneInfos} */ (
    jspb.Message.getWrapperField(this, xcommon_collection_pb.PhoneInfos, 13));
};


/**
 * @param {?proto.xcommon.PhoneInfos|undefined} value
 * @return {!proto.xcommon.GetPhoneSaleCaseResp} returns this
*/
proto.xcommon.GetPhoneSaleCaseResp.prototype.setPhoneinfo = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetPhoneSaleCaseResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.clearPhoneinfo = function() {
  return this.setPhoneinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.hasPhoneinfo = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * repeated string SupplierType = 14;
 * @return {!Array<string>}
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.getSuppliertypeList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.xcommon.GetPhoneSaleCaseResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.setSuppliertypeList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.xcommon.GetPhoneSaleCaseResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.addSuppliertype = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetPhoneSaleCaseResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.clearSuppliertypeList = function() {
  return this.setSuppliertypeList([]);
};


/**
 * optional bool DisplayRawPhone = 15;
 * @return {boolean}
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.getDisplayrawphone = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.xcommon.GetPhoneSaleCaseResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.setDisplayrawphone = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional int32 IsGP = 16;
 * @return {number}
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.getIsgp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetPhoneSaleCaseResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.setIsgp = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional string AccountStatus = 17;
 * @return {string}
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.getAccountstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetPhoneSaleCaseResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseResp.prototype.setAccountstatus = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SavePhoneSaleCaseReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SavePhoneSaleCaseReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SavePhoneSaleCaseReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    itemid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    caseid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    ticketid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    phoneconnected: jspb.Message.getFieldWithDefault(msg, 6, 0),
    phonecallinput: jspb.Message.getFieldWithDefault(msg, 7, ""),
    phonetime: jspb.Message.getFieldWithDefault(msg, 8, ""),
    phoneresult: jspb.Message.getFieldWithDefault(msg, 9, 0),
    desc: jspb.Message.getFieldWithDefault(msg, 10, ""),
    result: jspb.Message.getFieldWithDefault(msg, 11, 0),
    callid: jspb.Message.getFieldWithDefault(msg, 12, "0"),
    nextstep: jspb.Message.getFieldWithDefault(msg, 13, 0),
    birthday: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SavePhoneSaleCaseReq}
 */
proto.xcommon.SavePhoneSaleCaseReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SavePhoneSaleCaseReq;
  return proto.xcommon.SavePhoneSaleCaseReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SavePhoneSaleCaseReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SavePhoneSaleCaseReq}
 */
proto.xcommon.SavePhoneSaleCaseReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPhoneconnected(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonecallinput(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonetime(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPhoneresult(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setDesc(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setResult(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setCallid(value);
      break;
    case 13:
      var value = /** @type {!proto.xcommon.PhoneSaleNextStep} */ (reader.readEnum());
      msg.setNextstep(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setBirthday(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SavePhoneSaleCaseReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SavePhoneSaleCaseReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SavePhoneSaleCaseReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getPhoneconnected();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getPhonecallinput();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPhonetime();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPhoneresult();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getDesc();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getResult();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getCallid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      12,
      f
    );
  }
  f = message.getNextstep();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getBirthday();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.SavePhoneSaleCaseReq} returns this
*/
proto.xcommon.SavePhoneSaleCaseReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SavePhoneSaleCaseReq} returns this
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 ItemId = 2;
 * @return {number}
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SavePhoneSaleCaseReq} returns this
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 CaseId = 3;
 * @return {number}
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SavePhoneSaleCaseReq} returns this
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.setCaseid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 TicketId = 4;
 * @return {number}
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SavePhoneSaleCaseReq} returns this
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.setTicketid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 PhoneConnected = 6;
 * @return {number}
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.getPhoneconnected = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SavePhoneSaleCaseReq} returns this
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.setPhoneconnected = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string PhoneCallInput = 7;
 * @return {string}
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.getPhonecallinput = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SavePhoneSaleCaseReq} returns this
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.setPhonecallinput = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string PhoneTime = 8;
 * @return {string}
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.getPhonetime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SavePhoneSaleCaseReq} returns this
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.setPhonetime = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 PhoneResult = 9;
 * @return {number}
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.getPhoneresult = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SavePhoneSaleCaseReq} returns this
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.setPhoneresult = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string Desc = 10;
 * @return {string}
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.getDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SavePhoneSaleCaseReq} returns this
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.setDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int32 Result = 11;
 * @return {number}
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.getResult = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SavePhoneSaleCaseReq} returns this
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.setResult = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 CallId = 12;
 * @return {string}
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.getCallid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SavePhoneSaleCaseReq} returns this
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.setCallid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 12, value);
};


/**
 * optional PhoneSaleNextStep NextStep = 13;
 * @return {!proto.xcommon.PhoneSaleNextStep}
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.getNextstep = function() {
  return /** @type {!proto.xcommon.PhoneSaleNextStep} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.xcommon.PhoneSaleNextStep} value
 * @return {!proto.xcommon.SavePhoneSaleCaseReq} returns this
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.setNextstep = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional string Birthday = 14;
 * @return {string}
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.getBirthday = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SavePhoneSaleCaseReq} returns this
 */
proto.xcommon.SavePhoneSaleCaseReq.prototype.setBirthday = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SavePhoneSaleCaseResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SavePhoneSaleCaseResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SavePhoneSaleCaseResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SavePhoneSaleCaseResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SavePhoneSaleCaseResp}
 */
proto.xcommon.SavePhoneSaleCaseResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SavePhoneSaleCaseResp;
  return proto.xcommon.SavePhoneSaleCaseResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SavePhoneSaleCaseResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SavePhoneSaleCaseResp}
 */
proto.xcommon.SavePhoneSaleCaseResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SavePhoneSaleCaseResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SavePhoneSaleCaseResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SavePhoneSaleCaseResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SavePhoneSaleCaseResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SavePhoneSaleCaseResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.SavePhoneSaleCaseResp} returns this
*/
proto.xcommon.SavePhoneSaleCaseResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SavePhoneSaleCaseResp} returns this
 */
proto.xcommon.SavePhoneSaleCaseResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SavePhoneSaleCaseResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetPhoneSaleCaseLogReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetPhoneSaleCaseLogReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetPhoneSaleCaseLogReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPhoneSaleCaseLogReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    caseid: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetPhoneSaleCaseLogReq}
 */
proto.xcommon.GetPhoneSaleCaseLogReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetPhoneSaleCaseLogReq;
  return proto.xcommon.GetPhoneSaleCaseLogReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetPhoneSaleCaseLogReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetPhoneSaleCaseLogReq}
 */
proto.xcommon.GetPhoneSaleCaseLogReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetPhoneSaleCaseLogReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetPhoneSaleCaseLogReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetPhoneSaleCaseLogReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPhoneSaleCaseLogReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetPhoneSaleCaseLogReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetPhoneSaleCaseLogReq} returns this
*/
proto.xcommon.GetPhoneSaleCaseLogReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetPhoneSaleCaseLogReq} returns this
 */
proto.xcommon.GetPhoneSaleCaseLogReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetPhoneSaleCaseLogReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetPhoneSaleCaseLogReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.xcommon.GetPhoneSaleCaseLogReq} returns this
*/
proto.xcommon.GetPhoneSaleCaseLogReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetPhoneSaleCaseLogReq} returns this
 */
proto.xcommon.GetPhoneSaleCaseLogReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetPhoneSaleCaseLogReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 CaseId = 3;
 * @return {number}
 */
proto.xcommon.GetPhoneSaleCaseLogReq.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetPhoneSaleCaseLogReq} returns this
 */
proto.xcommon.GetPhoneSaleCaseLogReq.prototype.setCaseid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetPhoneSaleCaseLogResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetPhoneSaleCaseLogResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetPhoneSaleCaseLogResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetPhoneSaleCaseLogResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPhoneSaleCaseLogResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.PhoneSaleCaseLogBackend.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetPhoneSaleCaseLogResp}
 */
proto.xcommon.GetPhoneSaleCaseLogResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetPhoneSaleCaseLogResp;
  return proto.xcommon.GetPhoneSaleCaseLogResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetPhoneSaleCaseLogResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetPhoneSaleCaseLogResp}
 */
proto.xcommon.GetPhoneSaleCaseLogResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.PhoneSaleCaseLogBackend;
      reader.readMessage(value,proto.xcommon.PhoneSaleCaseLogBackend.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetPhoneSaleCaseLogResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetPhoneSaleCaseLogResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetPhoneSaleCaseLogResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPhoneSaleCaseLogResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.PhoneSaleCaseLogBackend.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetPhoneSaleCaseLogResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetPhoneSaleCaseLogResp} returns this
*/
proto.xcommon.GetPhoneSaleCaseLogResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetPhoneSaleCaseLogResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseLogResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetPhoneSaleCaseLogResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetPhoneSaleCaseLogResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.xcommon.GetPhoneSaleCaseLogResp} returns this
*/
proto.xcommon.GetPhoneSaleCaseLogResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetPhoneSaleCaseLogResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseLogResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetPhoneSaleCaseLogResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated PhoneSaleCaseLogBackend List = 3;
 * @return {!Array<!proto.xcommon.PhoneSaleCaseLogBackend>}
 */
proto.xcommon.GetPhoneSaleCaseLogResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.PhoneSaleCaseLogBackend>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.PhoneSaleCaseLogBackend, 3));
};


/**
 * @param {!Array<!proto.xcommon.PhoneSaleCaseLogBackend>} value
 * @return {!proto.xcommon.GetPhoneSaleCaseLogResp} returns this
*/
proto.xcommon.GetPhoneSaleCaseLogResp.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.PhoneSaleCaseLogBackend=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.PhoneSaleCaseLogBackend}
 */
proto.xcommon.GetPhoneSaleCaseLogResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.PhoneSaleCaseLogBackend, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetPhoneSaleCaseLogResp} returns this
 */
proto.xcommon.GetPhoneSaleCaseLogResp.prototype.clearListList = function() {
  return this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PhoneSaleCaseLogBackend.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PhoneSaleCaseLogBackend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PhoneSaleCaseLogBackend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PhoneSaleCaseLogBackend.toObject = function(includeInstance, msg) {
  var f, obj = {
    opname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    phonetime: jspb.Message.getFieldWithDefault(msg, 2, 0),
    phoneconnected: jspb.Message.getFieldWithDefault(msg, 3, 0),
    phoneresult: jspb.Message.getFieldWithDefault(msg, 4, ""),
    desc: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PhoneSaleCaseLogBackend}
 */
proto.xcommon.PhoneSaleCaseLogBackend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PhoneSaleCaseLogBackend;
  return proto.xcommon.PhoneSaleCaseLogBackend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PhoneSaleCaseLogBackend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PhoneSaleCaseLogBackend}
 */
proto.xcommon.PhoneSaleCaseLogBackend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpname(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPhonetime(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPhoneconnected(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneresult(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDesc(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PhoneSaleCaseLogBackend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PhoneSaleCaseLogBackend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PhoneSaleCaseLogBackend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PhoneSaleCaseLogBackend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOpname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPhonetime();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getPhoneconnected();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPhoneresult();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDesc();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string OpName = 1;
 * @return {string}
 */
proto.xcommon.PhoneSaleCaseLogBackend.prototype.getOpname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneSaleCaseLogBackend} returns this
 */
proto.xcommon.PhoneSaleCaseLogBackend.prototype.setOpname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 PhoneTime = 2;
 * @return {number}
 */
proto.xcommon.PhoneSaleCaseLogBackend.prototype.getPhonetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.PhoneSaleCaseLogBackend} returns this
 */
proto.xcommon.PhoneSaleCaseLogBackend.prototype.setPhonetime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 PhoneConnected = 3;
 * @return {number}
 */
proto.xcommon.PhoneSaleCaseLogBackend.prototype.getPhoneconnected = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.PhoneSaleCaseLogBackend} returns this
 */
proto.xcommon.PhoneSaleCaseLogBackend.prototype.setPhoneconnected = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string PhoneResult = 4;
 * @return {string}
 */
proto.xcommon.PhoneSaleCaseLogBackend.prototype.getPhoneresult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneSaleCaseLogBackend} returns this
 */
proto.xcommon.PhoneSaleCaseLogBackend.prototype.setPhoneresult = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Desc = 5;
 * @return {string}
 */
proto.xcommon.PhoneSaleCaseLogBackend.prototype.getDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneSaleCaseLogBackend} returns this
 */
proto.xcommon.PhoneSaleCaseLogBackend.prototype.setDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * @enum {number}
 */
proto.xcommon.PhoneSaleType = {
  PS_UNSPECIFIED: 0,
  PS_CONFIRM_LOAN: 1,
  PS_RECALL: 2
};

/**
 * @enum {number}
 */
proto.xcommon.PhoneSaleAction = {
  PHONE_SALE_ACTION_UNSPECIFIED: 0,
  PHONE_SALE_ACTION_PROCESS: 1,
  PHONE_SALE_ACTION_PART_COMPLETE: 2,
  PHONE_SALE_ACTION_COMPLETE: 3
};

/**
 * @enum {number}
 */
proto.xcommon.PhoneSaleNextStep = {
  PHONE_SALE_NEXT_STEP_UNSPECIFIED: 0,
  PHONE_SALE_NEXT_STEP_CONTINUE: 1,
  PHONE_SALE_NEXT_STEP_CLOSE: 2
};

module.exports = proto.xcommon;
